import React, {useState, useRef} from "react";
import {} from "reactstrap";
import {
    createMeeting,
    createMeetingVariables,
    editMeeting,
    editMeetingVariables,
    MeetingInput
} from "../../graphql/ql/operation-result-types";
import useAppContext from "../../hooks/useAppHook";
import {useMutation} from "@apollo/client";
import {EDIT_MEETING, UPDATE_MEETING} from "../../graphql/ql/schema";
import {toastService} from "../../services/toast.service";
import uuid from "react-uuid";
import {postAxiosService, postJsonAxiosService} from "../../services/callAxios";
import { UploadContext } from "../../context/AppStore";
import { useContext } from "react";

const UploadMeeting = (props) => {
    const {user} = useAppContext();
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [organizerName, setOrganizerName] = useState(user?.firstName + " " + user?.lastName || "");
    const [organizerEmail, setOrganizerEmail] = useState(user.email || "");
    const [files, setFiles] = useState<Array<any>>([]);
    const [sources, setSources] = useState<Array<string>>([]);
    const [errorTitle, setErrorTitle] = useState(false);
    const [errorOrganizerName, setErrorOrganizerName] = useState(false);
    const [errorOrganizerEmail, setErrorOrganizerEmail] = useState(false);
    const [errorAttendees, setErrorAttendees] = useState(false);
    const [errorFiles, setErrorFiles] = useState(false);
    const [attendee, setAttendee] = useState("");
    const [attendees, setAttendees] = useState<Array<string>>([]);
    const [isUploading, setIsUploading] = useState(false);

    const { isUploading: isUploadingMeetingFiles, uploadMeetingFiles } = useContext(UploadContext);

    const [updateMeeting] = useMutation<createMeeting, createMeetingVariables>(UPDATE_MEETING, {
        async onCompleted(data: createMeeting) {
            if (data != null) {
                return data?.createMeeting?.id;
            }
        },
        onError(e: any): void {

        },
    });

    const [editMeeting] = useMutation<editMeeting, editMeetingVariables>(EDIT_MEETING, {
        async onCompleted(data: editMeeting) {
            if (data != null) {
                return data?.editMeeting?.id;
            }
        },
        onError(e: any): void {

        },
    });

    const fileSelectedHandler = (e) => {
        let fileAttachments: any[] = [];
        let filenames: any[] = [];
        // let newFiles: DictionaryItem<String> = {};
        if (sources.length > 0)
            fileAttachments = fileAttachments.concat(sources);
        if (files.length > 0)
            filenames = filenames.concat(files);
        var largeFile =  false
        var clonedFiles = [...e.target.files]
        const dt = new DataTransfer()

        clonedFiles = clonedFiles.filter((file,index) => {
            if (file.size > 3e8) {
                largeFile = true;
                return false
            }
            dt.items.add(file)
            return true
        });
        e.target.files = dt.files
        clonedFiles.forEach(file => {
            let fileAttachment = {
                name: file.name,
                fileType: file.type,
                size: file.size,
            };
            fileAttachments.push(fileAttachment);
            filenames.push(file);
        });
        setSources(fileAttachments);
        setFiles(filenames);
        if (largeFile) {
            window.alert("Please upload a file smaller than 300 MB. For larger files contact support@getrafiki.ai");
            return;
        }
        setErrorFiles(false);
    }

    const removeFiles = (filesIndex: number) => {
        let index = files.splice(filesIndex, 1);
        let index1 = sources.splice(filesIndex, 1);
        setFiles([...files]);
        setSources([...sources]);
    }

    function setupAttendees() {
        let meetingAttendees: any[] = [];
        meetingAttendees.push({
            name: organizerName,
            email: organizerEmail,
            role: "organizer",
            status: "accepted"
        });
        attendees.forEach(att => {
            if ( !validateEmail(att["email"])) {
                setErrorAttendees(true);
                return;
            }
            let temp = {
                name: att["name"],
                email: att["email"],
                role: "attendees",
                status: "accepted"
            };
            meetingAttendees.push(temp);
        });

        return meetingAttendees;
    }

    function splitFilenameAndExtension(filename) {
        const lastDotIndex = filename.lastIndexOf('.');
        if (lastDotIndex === -1 || lastDotIndex === 0) {
            return { name: filename, extension: '' };
        }
        return {
            name: filename.substring(0, lastDotIndex),
            extension: filename.substring(lastDotIndex + 1),
        };
    }


    const handleAttendeeSelected = (): void => {
        if (attendee) {
            let nameAndEmail = attendee.split(",");
            if (nameAndEmail.length < 2 || !validateEmail(nameAndEmail[1]) ||
                nameAndEmail[0].trim() === "" || nameAndEmail[1].trim() === "" ||
                validateEmail(nameAndEmail[0])) {
                setErrorAttendees(true);
                return;
            }

            let temp = {
                name: nameAndEmail[0].trim(),
                email: nameAndEmail[1].trim(),
                role: "attendees",
                status: "accepted"
            };

            if (attendees.findIndex((key) => key === attendee) === -1) {
                const att1: any = [...attendees, attendee];
                setAttendees(att1);
            }
        }
    }

    const removeAttendee = (attendeeIndex: number) => {
        let index = attendees.splice(attendeeIndex, 1);
        setAttendees([...attendees]);
    }

    // const submit = (e: React.FormEvent<HTMLFormElement>) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     const form = e.currentTarget;
    //     const data = new FormData(form);
    //     handleSubmit(data);
    // }

    function validateEmail(e) {
        var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
        return String(e).search(filter) != -1;
    }

    const handleSubmit = async () => {
        // Check if user data is available before proceeding
        if (!user?.id || !user?.customer?.id) {
            // toastService.error("User data not available. Please try again.");
            return;
        }
        
        if (!title) {
            setErrorTitle(true);
            return;
        }
        else if (sources.length === 0) {
            setErrorFiles(true);
            return;
        } else if (!organizerName) {
            setErrorOrganizerName(true);
            return;
        } else if (!organizerEmail || !validateEmail(organizerEmail)) {
            setErrorOrganizerEmail(true);
            return;
        }
        if (attendees.length >= 1) {
            const hasInvalidEmail = attendees.some(att => !validateEmail(att["email"]));
            if (hasInvalidEmail) {
                setErrorAttendees(true);
                return;
            }
        }
        setIsUploading(true);
        let inputData = {
            "checkType": "isDownloadAllowed",
            "provider": "Uploaded",
            "meetingId": null,
            "downloadUrl": null,
        }
        let data1 = await postJsonAxiosService("users/checkLicenseConfig?user=" + organizerEmail, inputData);
        if (data1.data) {

        } else {
            toastService.error("Exhausted storage limits for current license. Please upgrade to be able to upload/record meetings.");
        }

        let meetingAttendees = setupAttendees();
        let externalAttendees = true;
        // let domain = organizerEmail?.split("@")[1];
        // attendees.forEach(att => {
        //     let participantDomain = att["email"]?.split("@")[1];
        //     if (domain !== participantDomain) {
        //         externalAttendees = true;
        //         return;
        //     }
        // });

        const meetingInput: MeetingInput = {
            title: title,
            description: description,
            subtitle: title,
            status: "Recorded",
            host: organizerEmail,
            owner: organizerEmail,
            customerId: user?.customer?.id,
            license: "Basic",
            duration: 0,
            date: new Date(),
            recordingStatus: true,
            callType: "Web Conferencing",
            callScope: "External",
            relation: {},
            sources: [],
            provider: "Uploaded",
            attendees: meetingAttendees,
        };
        updateMeeting({variables: {meeting: meetingInput}}).then(async (data) => {
            if (data?.data?.createMeeting?.id) {
                // Add null checks for user data before calling uploadMeetingFiles
                if (user?.id && user?.customer?.id) {
                    uploadMeetingFiles(files, data?.data?.createMeeting?.id, user.id, user.customer.id)
                } else {
                    // toastService.error("User data not available. Please try again.");
                    return;
                }
                setTimeout(() => {
                    props.toggle();
                    setIsUploading(false);
                }, 3000); // 3 second delay before closing
            } else {
                toastService.error("Failed to create");
            }
        })
            .catch((error) => {
                console.error('Error occurred:', error);
            });
    }

    const toTitleCase = (str) => {
        return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };

    const processAttendeesInput = (inputValue) => {
        // Split the input by comma to get individual emails
        const emails = inputValue.split(',').map(email => email.trim());
        const attendeesArray = emails.map(email => {
            const [namePart,] = email.split('@'); // Split email to get the name part
            const name = toTitleCase(namePart.replace('.', ' ')); // Replace dot with space and convert to title case
            return { name, email };
        });
        return attendeesArray;
    };


    const preventEnter = (e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } };
    const inputClass = "rf-upload-input";

    return (
        <div className="rf-upload-modal">
            {/* Header */}
            <div className="rf-upload-header">
                <div>
                    <div className="rf-upload-title">Upload Recording</div>
                    {isUploading && (
                        <div className="rf-upload-warning">
                            Please wait until upload completes. Do not close this dialog.
                        </div>
                    )}
                </div>
                {!isUploading && (
                    <button className="rf-upload-close" onClick={props.toggle}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width: 16, height: 16}}>
                            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                )}
            </div>

            {/* Body */}
            <div className="rf-upload-body">
                <div className="rf-upload-field">
                    <label className="rf-upload-label">Title <span style={{color: 'var(--rf-danger, #DC2626)'}}>*</span></label>
                    <input type="text" className={inputClass} autoFocus placeholder="Enter meeting title"
                           onKeyPress={preventEnter}
                           onChange={(e) => { setTitle(e.target.value); setErrorTitle(false); }} />
                    {errorTitle && <div className="rf-upload-error">Please enter a title</div>}
                </div>

                <div className="rf-upload-field">
                    <label className="rf-upload-label">Description</label>
                    <input type="text" className={inputClass} placeholder="Enter description"
                           onKeyPress={preventEnter}
                           onChange={(e) => { setDescription(e.target.value); }} />
                </div>

                <div className="rf-upload-field">
                    <label className="rf-upload-label">Organizer</label>
                    <div className="rf-upload-row">
                        <div className="rf-upload-half">
                            <input type="text" className={inputClass} value={organizerName} placeholder="Name"
                                   onKeyPress={preventEnter}
                                   onChange={(e) => { setOrganizerName(e.target.value); setErrorOrganizerName(false); }} />
                            {errorOrganizerName && <div className="rf-upload-error">Please enter organizer name</div>}
                        </div>
                        <div className="rf-upload-half">
                            <input type="text" className={inputClass} value={organizerEmail} placeholder="Email"
                                   onKeyPress={preventEnter}
                                   onChange={(e) => { setOrganizerEmail(e.target.value); setErrorOrganizerEmail(false); }} />
                            {errorOrganizerEmail && <div className="rf-upload-error">Please enter a valid email</div>}
                        </div>
                    </div>
                </div>

                <div className="rf-upload-field">
                    <label className="rf-upload-label">Attendees</label>
                    <input type="text" className={inputClass} placeholder="Comma separated emails (e.g. peter@abc.com, john@abc.com)"
                           onKeyPress={preventEnter}
                           onBlur={(e) => {
                               try {
                                   const attendeeArray = processAttendeesInput(e.target.value);
                                   if (attendeeArray && attendeeArray.length === 0) {
                                       setErrorAttendees(true);
                                   } else {
                                       setAttendees(attendeeArray);
                                       setErrorAttendees(false);
                                   }
                               } catch (error) {
                                   setErrorAttendees(true);
                               }
                           }} />
                    {errorAttendees && <div className="rf-upload-error">Please enter valid comma-separated email addresses</div>}
                </div>

                <div className="rf-upload-field">
                    <label className="rf-upload-label">
                        {user?.licenseConfig?.allowedVideoStorage !== -2
                            ? "Audio/Video File"
                            : "Audio File"}
                    </label>
                    <div className="rf-upload-file-hint">
                        {user?.licenseConfig?.allowedVideoStorage !== -2
                            ? "Supported: .mp3, .mp4, .m4a, .wav (max 300MB)"
                            : "Supported: .mp3, .m4a, .wav (max 300MB)"}
                    </div>
                    <label className="rf-upload-file-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width: 16, height: 16}}>
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="17 8 12 3 7 8" />
                            <line x1="12" y1="3" x2="12" y2="15" />
                        </svg>
                        {files.length > 0 ? files[0].name : "Choose file"}
                        <input type="file" style={{display: 'none'}}
                               accept={user?.licenseConfig?.allowedVideoStorage !== -2
                                   ? "video/x-m4v,video/mp4,audio/mp3,audio/m4a,audio/wav,audio/x-m4a,audio/x-wav"
                                   : "audio/mp3,audio/m4a,audio/wav"}
                               onChange={fileSelectedHandler} />
                    </label>
                    {errorFiles && <div className="rf-upload-error">Please select an audio/video file</div>}
                </div>
            </div>

            {/* Footer */}
            <div className="rf-upload-footer">
                <button className="rf-upload-cancel" onClick={props.toggle}>Cancel</button>
                <button className="rf-upload-submit" disabled={isUploading || isUploadingMeetingFiles} onClick={handleSubmit}>
                    {isUploading ? (
                        <>
                            <svg className="rf-upload-spinner" viewBox="0 0 24 24" style={{width: 14, height: 14}}>
                                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="3" strokeDasharray="31.4" strokeLinecap="round" />
                            </svg>
                            Uploading...
                        </>
                    ) : (
                        <>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width: 14, height: 14}}>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" />
                                <line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                            Upload
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default UploadMeeting;
